/**
 * Tensiometer range (50 cbar vs 100 cbar).
 *
 * The two transducers are electrically identical apart from gain — same 200 mV
 * zero point, same ADC resolution, same response time — so the backend cannot
 * tell them apart from the readings alone. The range has to be declared when
 * the sensor is installed.
 *
 * 50 cbar is the implicit default: it was the only unit until 2026, so every
 * sensor already in production carries no sub_type at all and must keep
 * resolving to the original calibration. Only 100 cbar is ever persisted.
 */
const TENSIOMETER_SUB_TYPES = Object.freeze({
  FIFTY_CBAR: '50cbar',
  HUNDRED_CBAR: '100cbar',
});

const TENSIOMETER_RANGE_OPTIONS = [
  { title: '50 cbar', value: TENSIOMETER_SUB_TYPES.FIFTY_CBAR },
  { title: '100 cbar', value: TENSIOMETER_SUB_TYPES.HUNDRED_CBAR },
];

/**
 * Which option the editor opens on for an existing sensor. Anything that is
 * not an explicit 100cbar — including a missing sub_type — is a 50 cbar unit.
 */
const tensiometerRangeFromSubType = (subType) =>
  subType === TENSIOMETER_SUB_TYPES.HUNDRED_CBAR
    ? TENSIOMETER_SUB_TYPES.HUNDRED_CBAR
    : TENSIOMETER_SUB_TYPES.FIFTY_CBAR;

/**
 * What gets written back. Empty for 50 cbar, so sensors already in production
 * are never given a sub_type, and so moving a sensor back to 50 cbar clears
 * the one it had.
 */
const persistedTensiometerSubType = (chosenRange) =>
  chosenRange === TENSIOMETER_SUB_TYPES.HUNDRED_CBAR
    ? TENSIOMETER_SUB_TYPES.HUNDRED_CBAR
    : '';

module.exports = {
  TENSIOMETER_SUB_TYPES,
  TENSIOMETER_RANGE_OPTIONS,
  tensiometerRangeFromSubType,
  persistedTensiometerSubType,
};
